<template>
    <div v-if="switchItem === 'news'">
        <!-- <div class="tags _mobile-hidden">
            <a
                :class="{'tagged__tags-item_active': filterCode === ''}"
                class="tagged__tags-item tagged__tags-item_withborders _mr-16 _mb-16-16"
                @click.prevent="filterTag('')"
            >
                Все
            </a>
            <a
                v-for="(item, index) in items"
                :key="index"
                class="tagged__tags-item tagged__tags-item_withborders _mb-16-16"
                :class="{'tagged__tags-item_active': filterCode === item.code}"
                @click.prevent="filterTag(item.code)"
            >
                {{ item.name }}
            </a>
        </div> -->
        <div>
            <d-select
                :items="itemsMobile"
                v-model="activity"
                static-label="Выберите сегмент"
            />
        </div>
    </div>
</template>

<script>
    import { ref, watch, computed } from 'vue';
    import { useStore } from '../../store';
    import { filter } from './services/filter';

    export default {
        name: "pressTags",
        props: {
            items: {
                type: Array,
                default: () => {
                    return []
                }
            },
            itemsMobile: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        setup() {
            let activity = ref('');
            const store = useStore();

            let filterCode = computed(() => {
                return store.state.press.filterCode;
            });

            let switchItem = computed(() => {
                return store.state.press.switcher;
            });

            const filterTag = (val) => {
                filter(val);
            }

            watch(activity , (val) => {
                filterTag(val);
            });

            return {
                activity,
                filterCode,
                switchItem,
                filterTag
            };
        },
    }
</script>
